// extracted by mini-css-extract-plugin
module.exports = {"root":"GoingOut_root__iYday","bg":"GoingOut_bg__yn4K4","title":"GoingOut_title__RbqbP","img":"GoingOut_img__X0Tbo","list":"GoingOut_list__FYCk4"};